import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
	selector: 'cp-empty-state',
	templateUrl: './empty.state.template.html',
	styleUrls: ['./empty.state.style.scss'],
	standalone:true,
	imports:[CommonModule],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class EmptyStateComponent {
	@Input() primaryText:string = "Empty state - primary text";
	@Input() secondaryText:string = "Empty state - secondary text";
	@Input() iconClass:string = "cp-icon-status_warning";

	constructor() {
	}

}
